<template>
  <mk-drawer
    :visible="visible"
    direction="rtl"
    :size="size"
    :hide-header="true"
    class="wraped-drawer"
    tabindex="0"
    @close="onClose"
  >
    <div
      class="custom-content"
      tabindex="0"
    >
      <div class="custom-head">
        <span class="custom-head-title">{{ title }}</span>
        <div>
          <ds-iconfont
            icon-class="icon-ds-guanbi1"
            class="close cursor"
            @click.native="onClose"
          ></ds-iconfont>
        </div>
      </div>
      <div class="custom-body">
        <slot />
      </div>
      <div
        v-if="showButton"
        class="button"
      >
        <mk-button-biz @click="onClose">
          {{ cancelText }}
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          @click="onConfirm"
        >
          {{ confirmText }}
        </mk-button-biz>
      </div>
    </div>
  </mk-drawer>
</template>

<script>
export default {
  name: 'WrapedDrawer',
  props: {
    // 是否可见
    visible: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '500px'
    },
    showButton: {
      type: Boolean,
      default: true
    },
    // drawer的标题
    title: {
      type: String,
      default: '默认标题'
    },
    // 取消按钮的文字
    cancelText: {
      type: String,
      default: '取消'
    },
    // 确认按钮的文字
    confirmText: {
      type: String,
      default: '提交'
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    // 点击确认按钮
    onConfirm () {
      this.$emit('on-confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.wraped-drawer {
  .custom-content {
    outline: none;
    height: 100%;
    display: flex;
    flex-direction: column;

    .custom-head-title {
      font-weight: 500;
    }
  }

  .custom-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #262626;
    font-size: 16px;
    height: 60px;
    padding: 0 20px;
    background: #fbfcfd;
    border-bottom: 1px solid #e8e8e8;
    border-radius: 2px 2px 0 0;
    flex-shrink: 0;

    .close {
      font-size: 14px;
      color: #bfbfbf;
    }
  }

  .custom-body {
    overflow-y: auto;
    flex: 1;
  }

  .button {
    background-color: #fff;
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
  }

  /deep/ .input-question {
    input.el-input__inner {
      padding-right: 60px !important;
    }
  }
}
</style>
